import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-493d171d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-full min-h-screen" }
const _hoisted_3 = {
  class: "px-4 lg:px-0 mx-auto mt-32",
  style: {"width":"96% !important"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-3xl text-gray-900" }, "Event Dashboard", -1))
const _hoisted_5 = { class: "w-full mt-10 flex md:flex-row flex-col" }
const _hoisted_6 = { class: "flex-1 pt-6 md:border-r md:border-b-0 border-b pb-6 md:pb-0 flex flex-col" }
const _hoisted_7 = { class: "flex flex-col md:mb-12" }
const _hoisted_8 = {
  style: {"height":"243px !important"},
  class: "flex-none rounded overflow-hidden mt-1 h-20 sm:h-24 md:h-32"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "flex-grow text-lg text-gray-900 md:pr-12"
}
const _hoisted_11 = { class: "text-xl" }
const _hoisted_12 = { class: "font-light" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Start: ", -1))
const _hoisted_14 = {
  key: 0,
  class: "font-light"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "End: ", -1))
const _hoisted_16 = { class: "flex-1 md:pl-8 md:pt-6 pt-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, "Total Tickets Sold", -1))
const _hoisted_18 = { class: "flex items-center mt-5" }
const _hoisted_19 = { class: "flex-grow w-full h-4 rounded-full border bg-white" }
const _hoisted_20 = { class: "flex-none px-4 font-light text-sm" }
const _hoisted_21 = { class: "font-light mt-3 text-sm" }
const _hoisted_22 = {
  class: "flex mt-10 flex-wrap",
  style: {"justify-content":"flex-start !important"}
}
const _hoisted_23 = { class: "px-2 pt-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl" }, "Net Sales", -1))
const _hoisted_25 = { class: "text-green-500 text-2xl font-semibold" }
const _hoisted_26 = { class: "px-2 pt-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl" }, "Gross Sales", -1))
const _hoisted_28 = { class: "text-green-500 text-2xl font-semibold" }
const _hoisted_29 = { class: "px-2 pt-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl" }, "Fees", -1))
const _hoisted_31 = { class: "text-green-500 text-2xl font-semibold" }
const _hoisted_32 = { class: "px-2 pt-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl" }, "Total Checked-In", -1))
const _hoisted_34 = { class: "text-green-500 text-2xl font-semibold" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mt-16 text-gray-900" }, "Sales by Ticket Type", -1))
const _hoisted_39 = {
  class: "test w-full mt-10 overflow-x-scroll table-auto",
  style: {"display":"block","overflow-x":"auto","white-space":"nowrap"}
}
const _hoisted_40 = {
  class: "font-light border-spacing-4 font-gray-800 text-sm",
  style: {"display":"table","width":"100%"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "bg-mute text-sm text-gray-800 h-10 text-left" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "pl-3" }, "Ticket Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Price"),
  /*#__PURE__*/_createElementVNode("th", null, "Sold / Remaining"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "End Sale"),
  /*#__PURE__*/_createElementVNode("th", null, "Visibility"),
  /*#__PURE__*/_createElementVNode("th", null, "Option")
], -1))
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "pl-3 py-3" }
const _hoisted_44 = { class: "font-normal text-green-500" }
const _hoisted_45 = ["onClick", "disabled"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick", "disabled"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "centerData space-x-4 py-4"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "No records present")
], -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 0,
  class: "text-3xl mt-16 text-gray-900"
}
const _hoisted_52 = {
  class: "test w-full mt-10 overflow-x-scroll table-auto",
  style: {"display":"block","overflow-x":"auto","white-space":"nowrap"}
}
const _hoisted_53 = {
  key: 0,
  class: "font-light border-spacing-4 font-gray-800 text-sm",
  style: {"display":"table","width":"100%"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "bg-mute text-sm text-gray-800 h-10 text-left" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "pl-3" }, "Donation Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Silver Package"),
  /*#__PURE__*/_createElementVNode("th", null, "Bronze Package"),
  /*#__PURE__*/_createElementVNode("th", null, "Gold Package"),
  /*#__PURE__*/_createElementVNode("th", null, "Sold"),
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "End Sale")
], -1))
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "pl-3 py-3" }
const _hoisted_57 = { class: "font-normal text-green-500" }
const _hoisted_58 = { class: "py-4" }
const _hoisted_59 = { class: "py-4" }
const _hoisted_60 = { class: "py-4" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "centerData space-x-4 py-4"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "No records present")
], -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = {
  key: 1,
  class: "flex justify-between flex-wrap"
}
const _hoisted_65 = { class: "text-3xl text-gray-900" }
const _hoisted_66 = {
  key: 2,
  class: "test w-full mt-10 overflow-x-scroll table-auto",
  style: {"display":"block","overflow-x":"auto","white-space":"nowrap"}
}
const _hoisted_67 = {
  class: "font-light border-spacing-4 font-gray-800 text-sm",
  style: {"display":"table","width":"100%"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "bg-mute text-sm text-gray-800 h-10 text-left" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "pl-3" }, "Food Vendor"),
  /*#__PURE__*/_createElementVNode("th", null, "Scans"),
  /*#__PURE__*/_createElementVNode("th", null, "Amount")
], -1))
const _hoisted_69 = { class: "border-b" }
const _hoisted_70 = { class: "pl-3 py-3" }
const _hoisted_71 = { class: "font-normal text-green-500" }
const _hoisted_72 = { class: "flex space-x-4 items-center py-4" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "3",
  class: "centerData space-x-4 py-4"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "No records present")
], -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mt-16 text-gray-900" }, "Recent Orders", -1))
const _hoisted_77 = {
  class: "test w-full mt-10 overflow-x-scroll table-auto",
  style: {"display":"block","overflow-x":"auto","white-space":"nowrap"}
}
const _hoisted_78 = {
  class: "font-light border-spacing-4 font-gray-800 text-sm",
  style: {"display":"table","width":"100%"}
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "bg-mute text-sm text-gray-800 h-10 text-left" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "pl-3 w-20" }, "Order No."),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Ticket Buyer"),
  /*#__PURE__*/_createElementVNode("th", null, "Qty"),
  /*#__PURE__*/_createElementVNode("th", null, "Price"),
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Payment"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "pl-3 py-3" }
const _hoisted_82 = { class: "font-normal text-green-500" }
const _hoisted_83 = { class: "flex space-x-4 items-center py-4" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_86 = { key: 0 }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "centerData space-x-4 py-4"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "No records present")
], -1))
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = {
  key: 1,
  class: "min-h-screen h-full overflow-y-scroll fixed top-0 w-full px-4 md:pt-32 sm:pt-24 pt-16",
  style: {"background-color":"#0000005c","width":"100vw"}
}
const _hoisted_90 = { class: "lg:w-2/5 md:w-1/2 relative sm:w-2/3 w-full mx-auto mb-10 bg-white rounded-xl py-6 px-4 sm:px-10" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl" }, "Acknowledgement", -1))
const _hoisted_92 = { class: "absolute right-10 top-6" }
const _hoisted_93 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-8\" data-v-493d171d><div class=\"flex flex-col space-y-1\" data-v-493d171d><p class=\"text-sm font-light text-gray-800\" data-v-493d171d> Thank you for choosing to sell tickets through MYLE. Look for an email from <span class=\"text-green-500\" data-v-493d171d><a href=\"mailto:admin1@myle.com\" data-v-493d171d>admin1@myle.com</a></span> that will give you the options to receive payment through Zelle, Paypal or ACH </p></div></div>", 1)
const _hoisted_94 = { class: "w-max mt-5 mb-3 mx-auto" }
const _hoisted_95 = {
  key: 2,
  class: "min-h-screen h-full overflow-y-scroll fixed top-0 w-full px-4 md:pt-32 sm:pt-24 pt-16",
  style: {"background-color":"#0000005c"}
}
const _hoisted_96 = { class: "lg:w-2/5 md:w-1/2 relative sm:w-2/3 w-full mx-auto mb-10 bg-white rounded-xl py-6 px-4 sm:px-10" }
const _hoisted_97 = { class: "text-green-500 text-xl" }
const _hoisted_98 = { class: "absolute right-10 top-6" }
const _hoisted_99 = { class: "text-sm font-light text-gray-800" }
const _hoisted_100 = { class: "grid md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-6 mt-8" }
const _hoisted_101 = { class: "flex flex-col space-y-1" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "TICKET NAME", -1))
const _hoisted_103 = { class: "text-sm font-light text-gray-800" }
const _hoisted_104 = { class: "flex flex-col space-y-1" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "TICKET TYPE", -1))
const _hoisted_106 = { class: "text-sm font-light text-gray-800" }
const _hoisted_107 = { class: "flex flex-col space-y-1" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "QUANTITY", -1))
const _hoisted_109 = { class: "text-sm font-light text-gray-800" }
const _hoisted_110 = { class: "flex flex-col space-y-1" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "ORDER NO.", -1))
const _hoisted_112 = { class: "text-sm font-light text-gray-800" }
const _hoisted_113 = { class: "flex flex-col space-y-1" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "PAYMENT TYPE", -1))
const _hoisted_115 = { class: "text-sm font-light text-gray-800" }
const _hoisted_116 = { class: "flex flex-col space-y-1" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "PAYMENT STATUS", -1))
const _hoisted_118 = { class: "text-sm font-light text-gray-800" }
const _hoisted_119 = { class: "flex flex-col col-span-2 space-y-1" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "PURCHASE DATE", -1))
const _hoisted_121 = { class: "text-sm font-light text-gray-800" }
const _hoisted_122 = { class: "w-max mt-5 mb-3 mx-auto" }
const _hoisted_123 = {
  key: 3,
  class: "min-h-screen h-full overflow-y-scroll fixed top-0 w-full px-4 md:pt-32 sm:pt-24 pt-16",
  style: {"background-color":"#0000005c"}
}
const _hoisted_124 = { class: "lg:w-2/5 md:w-1/2 relative sm:w-2/3 w-full mx-auto mb-10 bg-white rounded-xl py-6 px-4 sm:px-10" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl text-center" }, "Complimentary Ticket", -1))
const _hoisted_126 = { class: "absolute right-10 top-6" }
const _hoisted_127 = { class: "container" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_130 = { class: "row col-md-12 font-semibold" }
const _hoisted_131 = { style: {"font-size":"20px","font-weight":"bold"} }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_133 = { class: "row col-md-12" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Full Name", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_137 = { class: "row col-md-12" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email Address", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_141 = { class: "row col-md-12" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Quantity", -1))
const _hoisted_143 = ["value"]
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_146 = { class: "w-max mt-5 mb-3 mx-auto" }
const _hoisted_147 = {
  key: 5,
  class: "min-h-screen h-full overflow-y-scroll fixed top-0 w-full px-4 md:pt-32 sm:pt-24 pt-16",
  style: {"background-color":"#0000005c","width":"100vw"}
}
const _hoisted_148 = { class: "lg:w-2/5 md:w-1/2 relative sm:w-2/3 w-full mx-auto mb-10 bg-white rounded-xl py-6 px-4 sm:px-10" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl w-max mx-auto" }, "User Details", -1))
const _hoisted_150 = { class: "absolute right-10 top-6" }
const _hoisted_151 = { class: "mt-8" }
const _hoisted_152 = { class: "col-md-6" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "User Email", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_155 = { class: "col-md-6 mt-8" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "User Type", -1))
const _hoisted_157 = ["value"]
const _hoisted_158 = { class: "w-max mt-5 mb-3 mx-auto" }
const _hoisted_159 = ["disabled"]
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-3 p-2 mx-auto bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-xs mt-4" }, [
    /*#__PURE__*/_createElementVNode("b", null, "ADMIN"),
    /*#__PURE__*/_createTextVNode(" → Full access. Can add/remove event owners. ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "text-xs mt-4" }, [
    /*#__PURE__*/_createElementVNode("b", null, "EDITOR"),
    /*#__PURE__*/_createTextVNode(" → Can manage attendees but cannot view financial data. ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "text-xs mt-4" }, [
    /*#__PURE__*/_createElementVNode("b", null, "VIEWER"),
    /*#__PURE__*/_createTextVNode(" → Can view attendees, scan tickets & check-in guests only. ")
  ])
], -1))

export function render(_ctx, _cache) {
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")
  const _component_HeaderDashboard = _resolveComponent("HeaderDashboard")
  const _component_FooterDashboard = _resolveComponent("FooterDashboard")
  const _component_QRScanner = _resolveComponent("QRScanner")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_vue_element_loading, {
      active: _ctx.isloading,
      text: "MYLE",
      "text-style": _ctx.loadStyle,
      "is-full-screen": true,
      class: "h-full background-overlay",
      spinner: "bar-fade-scale",
      color: "#ffffff"
    }, null, 8, ["active", "text-style"]),
    (_ctx.selectedEvent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_HeaderDashboard),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        style: {"height":"auto","width":"100%","object-fit":"cover","padding-right":"10px"},
                        src: _ctx.currentUserPicure(_ctx.selectedEvent.image1) || '@/assets/img/user.jpeg',
                        class: "h-full",
                        alt: ""
                      }, null, 8, _hoisted_9)
                    ]),
                    (_ctx.selectedEvent)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.selectedEvent.title), 1),
                          _createElementVNode("p", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.selectedEvent.startDateTime)
                + ' ' + _ctx.getTime(_ctx.selectedEvent.startDateTime)), 1)
                          ]),
                          (_ctx.selectedEvent.endDateTime)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.selectedEvent.endDateTime) + '' +
                (_ctx.getTime(_ctx.selectedEvent.endDateTime))), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: "h-4 bg-green-300 rounded-full",
                        style: _normalizeStyle({
                'width': parseInt(_ctx.selectedEvent.totalSold * 100 / _ctx.selectedEvent.totalForSale) + '%'
              })
                      }, null, 4)
                    ]),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.selectedEvent.totalForSale ? (parseInt((_ctx.selectedEvent.totalSold
              * 100) / _ctx.selectedEvent.totalForSale) + '%') : '0%'), 1)
                  ]),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.selectedEvent.totalSold) + " Ticket(s) Sold / " + _toDisplayString(_ctx.selectedEvent.totalForSale), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("p", _hoisted_25, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['VIEWER', 'EDITOR'].includes(_ctx.getDetails) ? 'filter blur-md' : '')
                        }, _toDisplayString('$' + _ctx.selectedEvent.netAmount.toFixed(2)), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("p", _hoisted_28, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['VIEWER', 'EDITOR'].includes(_ctx.getDetails) ? 'filter blur-md' : '')
                        }, _toDisplayString('$' + _ctx.selectedEvent.grossAmount.toFixed(2)), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("p", _hoisted_31, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['VIEWER', 'EDITOR'].includes(_ctx.getDetails) ? 'filter blur-md' : '')
                        }, _toDisplayString('$' + (_ctx.selectedEvent.totalFees || 0).toFixed(2)), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("p", _hoisted_34, " #" + _toDisplayString((_ctx.selectedEvent.totalScannedCount || 0)) + " - " + _toDisplayString((_ctx.selectedEvent.totalScanned || 0) + '%'), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.getPay && _ctx.getPay(...args))),
                    disabled: _ctx.getDetails == 'VIEWER' || _ctx.getDetails == 'EDITOR',
                    class: "close mt-3 mt-2 px-2 py-2 text-sm ml-2 text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                  }, " Get Payment ", 8, _hoisted_35),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.scanData('ATTENDEES'))),
                    class: "close mt-2 ml-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out"
                  }, " Export Attendees Details "),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.scanData('FINANCIAL'))),
                    disabled: _ctx.getDetails == 'VIEWER'  || _ctx.getDetails == 'EDITOR',
                    class: "close mt-2 ml-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                  }, " Export Financial Details ", 8, _hoisted_36),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.navigateto && _ctx.navigateto(...args))),
                    class: "close ml-2 mt-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out"
                  }, " Search By Name "),
                  (_ctx.selectedEvent.activeWaitList)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.waitingList && _ctx.waitingList(...args))),
                        class: "close ml-2 mt-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out"
                      }, " Waiting List "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.addOwner && _ctx.addOwner(...args))),
                    disabled: (_ctx.getDetails != 'OWNER' && _ctx.getDetails != 'ADMIN'),
                    class: "close mt-3 mt-2 px-2 py-2 text-sm ml-2 text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                  }, " Add User ", 8, _hoisted_37)
                ])
              ]),
              _hoisted_38,
              _createElementVNode("table", _hoisted_39, [
                _createElementVNode("tbody", _hoisted_40, [
                  _hoisted_41,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sales, (rec) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "border-b",
                      onClick: $event => (_ctx.navigateToOrders({
            eventId: _ctx.selectedEvent.eventCode,
            ticketId: rec.ticketCode,
            type: 'ALL',
            page: 1
          }))
                    }, [
                      _createElementVNode("td", _hoisted_43, [
                        _createElementVNode("p", _hoisted_44, _toDisplayString(rec.ticketName), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString('$' + rec.price.toFixed(2)), 1),
                      _createElementVNode("td", null, _toDisplayString(rec.totalSold + ' / ' + rec.availableTickets), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.removeunderscore(rec.status)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.removeunderscore(rec.status) == "Removed" ||
                _ctx.removeunderscore(rec.status) == "Expired" ? "Ended" :
                _ctx.isBefore(rec.saleEndDateTime)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", null, _toDisplayString(rec.isHidden ? "Hidden" : 'Visible'), 1)
                      ]),
                      _createElementVNode("td", null, [
                        ( _ctx.removeunderscore(rec.status) == 'Active')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: $event => (_ctx.openm(rec, $event)),
                              disabled: _ctx.getDetails == 'VIEWER'  || _ctx.getDetails == 'EDITOR',
                              class: "close px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                            }, " Complimentary Ticket ", 8, _hoisted_45))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: $event => (_ctx.scanData1('ATTENDEES', rec.ticketCode, $event)),
                          class: "close mt-2 ml-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                        }, " Export Attendees Details ", 8, _hoisted_46),
                        _createElementVNode("button", {
                          onClick: $event => (_ctx.scanData1('FINANCIAL', rec.ticketCode, $event)),
                          disabled: _ctx.getDetails == 'VIEWER'  || _ctx.getDetails == 'EDITOR',
                          class: "close mt-2 ml-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                        }, " Export Financial Details ", 8, _hoisted_47)
                      ])
                    ], 8, _hoisted_42))
                  }), 256)),
                  (_ctx.sales.length <= 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_48, _hoisted_50))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.donationList.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_51, " Sales by Donation "))
                : _createCommentVNode("", true),
              _createElementVNode("table", _hoisted_52, [
                (_ctx.donationList.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_53, [
                      _hoisted_54,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donationList, (rec) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "border-b",
                          onClick: $event => (_ctx.navigateToOrders({
            eventId: _ctx.selectedEvent.eventCode,
            ticketId: rec.ticketCode,
            type: 'ALL',
            page: 1
          }))
                        }, [
                          _createElementVNode("td", _hoisted_56, [
                            _createElementVNode("p", _hoisted_57, _toDisplayString(rec.ticketName), 1)
                          ]),
                          _createElementVNode("td", _hoisted_58, _toDisplayString('$' + rec.lvlOneDonationPrice.toFixed(2)), 1),
                          _createElementVNode("td", _hoisted_59, _toDisplayString('$' + rec.lvlTwoDonationPrice.toFixed(2)), 1),
                          _createElementVNode("td", _hoisted_60, _toDisplayString('$' + rec.lvlThreeDonationPrice.toFixed(2)), 1),
                          _createElementVNode("td", null, _toDisplayString(rec.totalSold), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.removeunderscore(rec.status)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.isBefore(rec.saleEndDateTime)), 1)
                        ], 8, _hoisted_55))
                      }), 256)),
                      (_ctx.donationList.length <= 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_61, _hoisted_63))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.infoModal[_ctx.selectedEvent.eventCode] && _ctx.foodVendors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_65, _toDisplayString((_ctx.infoModal[_ctx.selectedEvent.eventCode] &&
            _ctx.infoModal[_ctx.selectedEvent.eventCode].title) ?
            _ctx.infoModal[_ctx.selectedEvent.eventCode].title : 'Sales by Ticket Type'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.exportfood && _ctx.exportfood(...args))),
                        class: "close mt-3 ml-3 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out text-right"
                      }, _toDisplayString((_ctx.infoModal[_ctx.selectedEvent.eventCode] &&
            _ctx.infoModal[_ctx.selectedEvent.eventCode].buttonTitle) ?
            _ctx.infoModal[_ctx.selectedEvent.eventCode].buttonTitle : ''), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.infoModal[_ctx.selectedEvent.eventCode] && _ctx.foodVendors.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_66, [
                    _createElementVNode("tbody", _hoisted_67, [
                      _hoisted_68,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foodVendors, (rec) => {
                        return (_openBlock(), _createElementBlock("tr", _hoisted_69, [
                          _createElementVNode("td", _hoisted_70, [
                            _createElementVNode("p", _hoisted_71, _toDisplayString(rec.user.fullName), 1)
                          ]),
                          _createElementVNode("td", _hoisted_72, _toDisplayString((rec.totalScans || 0)), 1),
                          _createElementVNode("td", null, _toDisplayString('$' + ((rec.totalScans || 0) * 15).toFixed(2)), 1)
                        ]))
                      }), 256)),
                      (_ctx.foodVendors.length <= 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_73, _hoisted_75))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_76,
              _createElementVNode("table", _hoisted_77, [
                _createElementVNode("tbody", _hoisted_78, [
                  _hoisted_79,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (rec) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "border-b",
                      onClick: $event => (_ctx.open(rec))
                    }, [
                      _createElementVNode("td", _hoisted_81, [
                        _createElementVNode("p", _hoisted_82, _toDisplayString(rec.orderCode), 1)
                      ]),
                      _createElementVNode("td", _hoisted_83, [
                        _createTextVNode(_toDisplayString(rec.user.fullName) + " ", 1),
                        _hoisted_84,
                        _createTextVNode(" " + _toDisplayString(rec.user.email), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(rec.totalPurchasedTickets), 1),
                      _createElementVNode("td", null, _toDisplayString('$' + rec.totalPaid.toFixed(2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.getDate(rec.purchasedDateTime)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.removeunderscore(rec.paymentStatus)), 1),
                      _hoisted_85
                    ], 8, _hoisted_80))
                  }), 256)),
                  (_ctx.list.length <= 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_86, _hoisted_88))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.navigateToOrders({
          eventId: _ctx.selectedEvent.eventCode,
          ticketId: '',
          type: 'ALL',
          page: 1
        }))),
                class: "close mt-3 ml-3 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out",
                style: {"width":"5rem"}
              }, " See all ")
            ])
          ]),
          _createVNode(_component_FooterDashboard)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _hoisted_91,
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("p", {
                class: "close text-xl opacity-70 font-black text-green-500 cursor-pointer",
                onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.close && _ctx.close(...args)))
              }, " ╳ ")
            ]),
            _hoisted_93,
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.close && _ctx.close(...args))),
                class: "close px-8 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out mt-5"
              }, " I acknowledge ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModel1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("p", _hoisted_97, _toDisplayString(_ctx.tickRecord.user.fullName), 1),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("p", {
                class: "close text-xl opacity-70 font-black text-green-500 cursor-pointer",
                onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.close1 && _ctx.close1(...args)))
              }, " ╳ ")
            ]),
            _createElementVNode("p", _hoisted_99, _toDisplayString(_ctx.tickRecord.user.email), 1),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _hoisted_102,
                _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.tickRecord.ticket.ticketName), 1)
              ]),
              _createElementVNode("div", _hoisted_104, [
                _hoisted_105,
                _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.tickRecord.ticket.ticketType), 1)
              ]),
              _createElementVNode("div", _hoisted_107, [
                _hoisted_108,
                _createElementVNode("p", _hoisted_109, _toDisplayString(_ctx.tickRecord.totalPurchasedTickets), 1)
              ]),
              _createElementVNode("div", _hoisted_110, [
                _hoisted_111,
                _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.tickRecord.orderCode), 1)
              ]),
              _createElementVNode("div", _hoisted_113, [
                _hoisted_114,
                _createElementVNode("p", _hoisted_115, _toDisplayString(_ctx.tickRecord.paymentType), 1)
              ]),
              _createElementVNode("div", _hoisted_116, [
                _hoisted_117,
                _createElementVNode("p", _hoisted_118, _toDisplayString(_ctx.tickRecord.paymentStatus.replace('_', ' ')), 1)
              ]),
              _createElementVNode("div", _hoisted_119, [
                _hoisted_120,
                _createElementVNode("p", _hoisted_121, _toDisplayString(_ctx.getDate(_ctx.tickRecord.purchasedDateTime) + ' ' +
          _ctx.getTime(_ctx.tickRecord.purchasedDateTime) + (_ctx.tickRecord.noEndDate ? (' - '
          + _ctx.getTime(_ctx.tickRecord.purchasedDateTime)) : '')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.close1 && _ctx.close1(...args))),
                class: "close px-8 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out mt-5"
              }, " Close ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.reissuemodal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, [
            _hoisted_125,
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("p", {
                class: "close text-xl opacity-70 font-black text-green-500 cursor-pointer",
                onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.closem && _ctx.closem(...args)))
              }, " ╳ ")
            ]),
            _createElementVNode("div", _hoisted_127, [
              _hoisted_128,
              _hoisted_129,
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("h1", _hoisted_131, " Ticket: " + _toDisplayString(_ctx.tickRecord.ticketName), 1)
              ]),
              _hoisted_132,
              _createElementVNode("div", _hoisted_133, [
                _hoisted_134,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "ddown",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.uName) = $event)),
                  class: "w-full border h-10 mt-2 border-gray-300 rounded wful1",
                  style: {"outline":"none !important","border-width":"1px !important","border-right":"1px solid #00000029 !important"}
                }, null, 512), [
                  [_vModelText, _ctx.uName]
                ]),
                _hoisted_135,
                _hoisted_136
              ]),
              _createElementVNode("div", _hoisted_137, [
                _hoisted_138,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "ddown",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.uEmail) = $event)),
                  class: "w-full border h-10 mt-2 border-gray-300 rounded wful1",
                  style: {"outline":"none !important","border-width":"1px !important","border-right":"1px solid #00000029 !important"}
                }, null, 512), [
                  [_vModelText, _ctx.uEmail]
                ]),
                _hoisted_139,
                _hoisted_140
              ]),
              _createElementVNode("div", _hoisted_141, [
                _hoisted_142,
                _withDirectives(_createElementVNode("select", {
                  class: "w-full border h-10 mt-2 border-gray-300 rounded wful1",
                  style: {"outline":"none !important","border-width":"1px !important","border-right":"1px solid #00000029 !important"},
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.quantity) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qlist, (x) => {
                    return (_openBlock(), _createElementBlock("option", { value: x }, _toDisplayString(x), 9, _hoisted_143))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.quantity]
                ]),
                _hoisted_144,
                _hoisted_145
              ])
            ]),
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.submitm && _ctx.submitm(...args))),
                class: _normalizeClass([{'opa-50': !_ctx.uEmail.trim().length || !_ctx.uName.trim().length  || !_ctx.invalidTicketEmail() }, "close px-8 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out mt-5"])
              }, " Submit ", 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showQRModal)
      ? (_openBlock(), _createBlock(_component_QRScanner, {
          key: 4,
          selectedEvent: _ctx.selectedEvent,
          onClose: _ctx.closeQRModal
        }, null, 8, ["selectedEvent", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showOwnerModel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
          _createElementVNode("div", _hoisted_148, [
            _hoisted_149,
            _createElementVNode("div", _hoisted_150, [
              _createElementVNode("p", {
                class: "close text-xl opacity-70 font-black text-green-500 cursor-pointer",
                onClick: _cache[17] || (_cache[17] = (...args) => (_ctx.closem1 && _ctx.closem1(...args)))
              }, " ╳ ")
            ]),
            _createElementVNode("div", _hoisted_151, [
              _createElementVNode("div", _hoisted_152, [
                _hoisted_153,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.userEmail) = $event)),
                  placeholder: "Email",
                  class: "w-full border h-10 mt-2 border-gray-300 rounded wful1"
                }, null, 512), [
                  [_vModelText, _ctx.userEmail]
                ]),
                _hoisted_154
              ]),
              _createElementVNode("div", _hoisted_155, [
                _hoisted_156,
                _withDirectives(_createElementVNode("select", {
                  class: "w-full border h-10 mt-2 border-gray-300 rounded wful1",
                  style: {"outline":"none !important","border-width":"1px !important","border-right":"1px solid #00000029 !important"},
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.ownershipType) = $event))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Admin','Editor','Viewer'], (x) => {
                    return _createElementVNode("option", { value: x }, _toDisplayString(x), 9, _hoisted_157)
                  }), 64))
                ], 512), [
                  [_vModelSelect, _ctx.ownershipType]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("button", {
                onClick: _cache[20] || (_cache[20] = (...args) => (_ctx.addOwners && _ctx.addOwners(...args))),
                disabled: !_ctx.invalidEmail,
                class: "close px-8 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out mt-5 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
              }, " Add User ", 8, _hoisted_159)
            ]),
            _hoisted_160
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}